import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Tree.module.scss';

import Tree from './Tree';
import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import FlexRow from 'Flow2/components/UI/Container/FlexRow'
import FlexCol from 'Flow2/components/UI/Container/FlexColumn'

import { injectIntl } from 'react-intl';
import * as actions from 'store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faMinusSquare, faFolderOpen, faFolder, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';

import * as HF from 'Flow2/util/helperFunctions';

export const getTree = (props) => {
    try {
        if (props.group.setting && props.group.setting.vifogra_tags) {
            return JSON.parse(props.group.setting.vifogra_tags.value);
        }
    } catch (ex) {
        console.log(ex);
        return [];
    }
    return [];
}

/*
export const getSelectedData = (list = {}, selected = []) => {
    const ids = selected.filter(id => {
        if(list.hasOwnProperty(id.replace("-", ""))) return true;
        return false;
    });
    return ids;
}
*/
export const getSelectedIds = (list = {}, selected = []) => {
    console.log(selected);
    const ids = selected.filter(id => {
        if (list.hasOwnProperty(id.replace("-", ""))) return true;
        return false;
    });
    return ids;
}

export const getSelectedKeywords = (list = {}, ids = []) => {
    const keywords = ids.map(id => {
        return list[id].name;
    });
    return keywords;
}

class TagTree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            selected: props.selected || [],
            keywords: props.keywords || [],
            tree: [],
            list: {}
        }
    }

    static init = (props) => {
        const tree = getTree(props);
        const list = HF.getListFromTree(tree, "id", "children");
        const selected = getSelectedIds(list, props.selected);
        const keywords = getSelectedKeywords(list, selected);

        console.log(list);
        
        const state = { tree, list, selected, keywords };

        props.onLoaded(selected, keywords);

        //console.log(state);
        return state;
    }

    onAdd = (data) => {
        let selected = [...this.state.selected];
        let keywords = [...this.state.keywords];
        
        if(this.props.singleSelect) {
            selected = [ data.id ];
            keywords = [ data.name ];
        } else {
            if (selected.indexOf(data.id) === -1) {
                selected.push(data.id);
                keywords.push(data.name);
            }
        }
        this.props.onSelect(selected, keywords);
        this.setState({ selected: selected, keywords: keywords });
    }

    onRemove = (data) => {
        let selected = [...this.state.selected];
        let keywords = [...this.state.keywords];
        let index = selected.indexOf(data.id);
        if (index !== -1) {
            selected.splice(index, 1);
            index = keywords.indexOf(data.name);
            if (index !== -1) {
                keywords.splice(index, 1);
            }
            this.props.onSelect(selected, keywords);
            this.setState({ selected: selected, keywords: keywords });
        }
    }

    isSelected = (data) => {
        return (this.state.selected.indexOf(data.id) === -1) ? classes.notSelected : classes.isSelected;
    }

    onClick = (data) => {
        if (this.state.selected.indexOf(data.id) === -1) {
            this.onAdd(data);
        } else {
            this.onRemove(data);
        }
    }

    render() {
        return (
            <Tree
                title={this.props.title || "Tags"}
                data={this.state.tree || []}
                selected={this.state.selected}
                onClick={this.onClick}
                onAdd={this.onAdd}
                onRemove={this.onRemove}
                isSelected={this.isSelected}
                loading={this.state.loading}
                singleSelect={this.props.singleSelect || false}
                extraContent={this.props.extraContent}
                filter={this.props.filter} />
        );
    }

    componentDidMount = () => {
        //console.log("TREE MOUNT");
        this.props.loadGroupSetting(this.props.user.groupid);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        //console.log("getDerivedStateFromProps", nextProps.loading);
        if (!nextProps.loading && prevState.loading) {
            const state = TagTree.init(nextProps);
            return {
                loading: nextProps.loading,
                ...state
                /*tree: getTree(nextProps)*/
            }
        }
        return null;
    }
};



const mapStateToProps = (state) => {
    return {
        user: state.auth.user,
        group: state.admin.group,
        loading: !state.admin.group.loaded
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadGroupSetting: (groupid) => dispatch(actions.loadGroupSetting(groupid))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TagTree));
